import { AppState } from 'store/store';

export const templatesListSelector = (state: AppState) => state.templates.list;
export const previewSelector = (state: AppState) => state.templates.preview;
export const documentRequestSelector = (state: AppState) => state.templates.documentRequest;
